import { TJob } from '../../../lib/types';

export const JOB_ASPECT_STATUS = {
  SETUP_REQUIRED: 'Setup Required',
  NOT_REQUIRED: 'Not Required',
  LINK_REQUIRED: 'Link Required',
};

export const DEFAULT_JOB_ASPECT_STATUSES: TJob['aspectStatuses'] = {
  insulationStatus: 'Setup Required',
  isolationStatus: 'Setup Required',
  mocStatus: 'Setup Required',
  leakTestPackStatus: 'Setup Required',
  liftPlanStatus: 'Setup Required',
  procedureStatus: 'Setup Required',
  purchaseOrderStatus: 'Setup Required',
  scaffoldStatus: 'Setup Required',
  workpackStatus: 'Setup Required',
  gocStatus: 'Setup Required',
  scheduleStatus: '',
  fieldWalkStatus: '',
  permitStatus: 'Setup Required',
};
